import React, { useEffect } from "react";
import "./privacyPolicy.css";
import { Helmet } from "react-helmet";


export default function PrivacyPolicy() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Privacy Policy - Your Data & Security</title>
        <meta
          name="description"
          content="Read SHOP.CO’s privacy policy to learn how we protect your personal information, ensure security, and handle your data responsibly."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/help/privacy-policy/"
        />
      </Helmet>
      <div className="privacy-container">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
          <p>We value your privacy and are committed to protecting your personal information.</p>
        </header>

        <section className="privacy-section">
          <h2>1. Information We Collect</h2>
          <p>
            We collect personal information you provide such as your name, email, address, and payment details when you make a purchase or sign up for our newsletter.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. How We Use Your Information</h2>
          <p>
            We use your information to process orders, provide customer support, send updates or promotional emails, and improve our services.
          </p>
        </section>

        <section className="privacy-section">
          <h2>3. Sharing Your Data</h2>
          <p>
            Your data is never sold. We may share your information with trusted third parties (like delivery services) only for fulfilling your order.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. Data Protection</h2>
          <p>
            We implement strict security measures to protect your data. All transactions are encrypted using SSL.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Cookies</h2>
          <p>
            We use cookies to enhance your browsing experience, analyze traffic, and serve relevant content. You can manage cookie settings in your browser.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Your Rights</h2>
          <p>
            You have the right to access, update, or delete your personal data. Contact us if you wish to exercise any of these rights.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Changes to this Policy</h2>
          <p>
            We may update this policy from time to time. Please review it periodically. Last update will be reflected below.
          </p>
        </section>

        <footer className="privacy-footer">
          <p>Last Updated: July 2025</p>
        </footer>
      </div>
    </>
  );
}
